import React from "react";
import { Link } from "react-router-dom";

import { routes } from "routes";
import "components/buttons/BaseButton/BaseButton.scss";

import "./MigrateImgurPage.scss";

export const MigrateImgurSuccessPage = (): JSX.Element => {
  document.title = "Migrate from Imgur";

  return (
    <div className="migratePage narrow page">
      <h1>Transfer your content from Imgur</h1>

      <p>Great! We have successfully connected your account to imgur.&nbsp;
      The migration is now processing.&nbsp; There is a limit on how fast we can
      transfer content so the completion of the process is dependent on the amount
      of content being transferred.</p>

      <p>Transferred content will show up in your <Link to={routes.manageProfile()}>manage section</Link>.</p>
    </div>
  );
};
